;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "afrimoney",
  props: ["status_api_url", "invoice_no", "callback_url"],
  data: function data() {
    return {
      mpgs_url: null,
      currency: null,
      logo: null,
      invoice_amount: 0,
      agent_fee: 0,
      fee: 0,
      total_amount: 0,
      bill_ref: null,
      service_id: null,
      loaded: false,
      error_message: null,
      processing: false,
      gateway_id: null,
      notification_url: null,
      base_url: "",
      api_token: null,
      is_initiated: false
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.mpgs_url = this.$attrs["mpgs_api_url"];
    this.notification_url = this.$attrs["notification_url"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.logo = this.$attrs["logo"];
    this.bill_ref = this.$attrs["bill_ref"];
    this.service_id = this.$attrs["service_id"];
    this.gateway_id = this.$attrs["gid"];
    this.base_url = this.$attrs["base_url"];
    this.set_total_amount();

    $("#afriMoneyProcessingModal").on("shown.bs.modal", function () {
      _this.is_initiated = false;
    });

    $("#afriMoneyProcessingModal").on("hidden.bs.modal", function () {
      _this.is_initiated = false;
      _this.destroyTimer();
    });
  },
  methods: {
    destroyTimer: function destroyTimer() {
      this.$refs.timer.destroyTimer();
    },

    getOauthToken: function getOauthToken() {
      var _this2 = this;

      var url = this.base_url + "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this2.api_token = response.data.token;
      }).catch(function (error) {}).then(function () {});
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = Math.ceil(parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
    },
    initiate_payment: function initiate_payment() {
      var _payload,
          _this3 = this;

      var urlIs = this.base_url + "/api/payment/afrimoney/checkout";

      if (!this.msisdn) {
        this.error_message = "Please enter the mobile number !";
        return;
      }
      this.error_message = null;
      this.processing = true;

      var payload = (_payload = {
        msisdn: this.msisdn,
        invoice_number: this.invoice_no,
        amount: this.total_amount
      }, (0, _defineProperty3.default)(_payload, "msisdn", this.msisdn), (0, _defineProperty3.default)(_payload, "notification_url", this.notification_url), (0, _defineProperty3.default)(_payload, "gateway_id", this.gateway_id), _payload);

      var api_headers = {
        Authorization: "Bearer " + this.api_token
      };

      Vue.axios.post(urlIs, payload, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _this3.error_message = "Unable to initiate at the moment. Try again later !";
          _this3.processing = false;
        } else {
          _this3.msisdn = null;
          _this3.processing = false;
          _this3.is_initiated = true;
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Check your phone for instructions",
            showConfirmButton: false,
            timer: 2500
          });
        }
      }).catch(function () {
        _this3.error_message = "Unable to initiate at the moment. Try again later !";
        _this3.msisdn = null;
        _this3.processing = false;
        _this3.is_initiated = false;
      }).then(function () {
        _this3.processing = false;
        _this3.msisdn = null;
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"afriMoneyProcessingModal","tabindex":"-1","role":"dialog","aria-labelledby":"afriMoneyProcessingModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay using AfriMoney")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.total_amount))])]),_vm._v(" "),_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Total Due*")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.total_amount))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.error_message)?_c('div',{staticClass:"row"},[_c('span',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.error_message))])]):_vm._e(),_vm._v(" "),_c('form',[(!_vm.is_initiated)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(!_vm.processing)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"form-control",attrs:{"type":"text","pattern":"\\d*","maxlength":"9","placeholder":"Enter mobile number"},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.processing)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"form-control",attrs:{"type":"text","pattern":"\\d*","maxlength":"9","disabled":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col"},[(!_vm.processing)?_c('button',{staticClass:"btn btn-sm btn-outline-primary mb-2",attrs:{"type":"button"},on:{"click":function($event){return _vm.initiate_payment()}}},[_vm._v("\n                          Proceed to Pay\n                        ")]):_vm._e(),_vm._v(" "),(_vm.processing)?_c('button',{staticClass:"btn btn-sm btn-warning mb-2",attrs:{"type":"button","data-toggle":"modal"}},[_vm._v("\n                          Processing ...\n                        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.is_initiated)?_c('div',{staticClass:"row"},[_c('p',{staticClass:"alert alert-info"},[_vm._v("\n                        Transaction Initiated. Click the complete button once\n                        you complete payment or refresh page to retry.\n                      ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":_vm.destroyTimer}},[_vm._v("Cancel")]),_vm._v(" "),_c('complete-button',{ref:"timer",attrs:{"gateway":"afrimoney","poll_external":"true","gateway_id":_vm.gateway_id,"status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_no,"callback_url":_vm.callback_url}})],1)])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32ccf89c", __vue__options__)
  } else {
    hotAPI.reload("data-v-32ccf89c", __vue__options__)
  }
})()}